<template>
  <div class="event-mapping">
    <h2>Event Mapping</h2>
    <div class="event-source">
      <h3>Vivid Seats</h3>
      <input type="date" v-model="vividDate" @change="fetchVividEvents" />
      <select v-model="selectedVividEvent">
        <option v-for="event in vividEvents" :key="event.id" :value="event.id">
          {{ event.name }}
        </option>
      </select>
    </div>
    <div class="event-source">
      <h3>JustPark</h3>
      <input type="date" v-model="justParkDate" @change="fetchJustParkEvents" />
      <select v-model="selectedJustParkEvent">
        <option v-for="event in justParkEvents" :key="event.id" :value="event.id">
          {{ event.name }}
        </option>
      </select>
    </div>
  </div>
</template>

<script>
export default {
  name: 'EventMapping',
  data() {
    return {
      vividDate: '',
      vividEvents: [],
      selectedVividEvent: null,
      justParkDate: '',
      justParkEvents: [],
      selectedJustParkEvent: null
    };
  },
  methods: {
    async fetchVividEvents() {
      // TODO: Replace with real API call
      // Simulate fetching events for the selected date
      this.vividEvents = [
        { id: 1, name: 'Vivid Event A' },
        { id: 2, name: 'Vivid Event B' }
      ];
      this.selectedVividEvent = null;
    },
    async fetchJustParkEvents() {
      // TODO: Replace with real API call
      // Simulate fetching events for the selected date
      this.justParkEvents = [
        { id: 101, name: 'JustPark Event X' },
        { id: 102, name: 'JustPark Event Y' }
      ];
      this.selectedJustParkEvent = null;
    }
  }
};
</script>

<style scoped>
.event-mapping {
  display: flex;
  gap: 2rem;
}
.event-source {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}
</style>
